import { Box, Divider, Flex, P } from "orcs-design-system";
import NotificationDot from "../NotificationDot";
import type { InsightDataRow } from "../../types";

type InsightDataRowItemProps = {
  data: InsightDataRow;
  isFirst: boolean;
  measureType: string | undefined;
};

const InsightDataRowItem = ({
  data,
  isFirst,
  measureType,
}: InsightDataRowItemProps) => (
  <Box
    bg={isFirst ? "#f2f2f2" : "transparent"}
    pl={isFirst ? "s" : "r"}
    pr="s"
    py="r"
  >
    <Flex mb="r" justifyContent="space-between">
      <P fontSize="1.2rem">{data?.group.name}</P>
      <Flex
        justifyContent={data?.attributes?.display ? "space-between" : "end"}
        alignItems="center"
      >
        <NotificationDot
          met={data?.met}
          detail={data?.detail}
          ruleDetail={data?.ruleDetail}
        />
        <P fontSize="1.2rem" pl="s">
          {data.value}
          {measureType === "percentage" ? "%" : ""}
        </P>
      </Flex>
    </Flex>
    <Divider dash light mt="r" />
  </Box>
);

export default InsightDataRowItem;
